import { ref, withParams } from 'vuelidate/lib/validators/common';
import moment from 'moment';

export default maxDateValue => withParams(
  { type: 'maxDateValue', eq: maxDateValue },
  function (value, parentVm) {
    const other = ref(maxDateValue, this, parentVm);
    if (other && value) {
      const otherM = moment(other);
      otherM.startOf('day');
      const valM = moment(value);
      valM.startOf('day');

      return valM.diff(otherM) <= 0;
      // return value.getTime() < other.getTime()
    }
    return false;
  },
);
